import type { InvoiceStatus } from '../types'

interface Props {
  status: InvoiceStatus | string
  className?: string
}

const statusConfig: Record<string, { bg: string; text: string; label: string }> = {
  pending: { bg: 'bg-ica-amber/12', text: 'text-ica-amber', label: 'Pending' },
  overdue: { bg: 'bg-ica-red/12', text: 'text-ica-red', label: 'Overdue' },
  paid: { bg: 'bg-ica-green/12', text: 'text-ica-green', label: 'Paid' },
  paused: { bg: 'bg-ica-text-muted/12', text: 'text-ica-text-muted', label: 'Paused' },
  scheduled: { bg: 'bg-ica-accent-soft', text: 'text-ica-accent', label: 'Scheduled' },
  sent: { bg: 'bg-ica-green/12', text: 'text-ica-green', label: 'Sent' },
  skipped: { bg: 'bg-ica-text-muted/12', text: 'text-ica-text-muted', label: 'Skipped' },
  failed: { bg: 'bg-ica-red/12', text: 'text-ica-red', label: 'Failed' },
}

export default function StatusBadge({ status, className = '' }: Props) {
  const config = statusConfig[status] || statusConfig.pending

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${config.bg} ${config.text} ${className}`}
    >
      {config.label}
    </span>
  )
}
